import { components } from '@/utils'

import preloader from '@/components/preloader'
import toc from '@/components/services/documentation/toc'
import { className } from '@/components/services/documentation/utils'

function renderToc(h) {
  return h(
    toc,
    {
      props: {
        headings: this.headings
      }
    }
  )
}

function renderPreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder pa-5'
      },
      [ h(preloader) ]
    )
  }
}
function renderContent(h) {
  if (this.html) {
    return h(
      'div',
      {
        class: `${className}-content`,
        domProps: { innerHTML: this.html }
      }
    )
  }
}

function renderBody(h) {
  return h(
    'div',
    {
      class: `${className}-body`,
      ref: 'body'
    },
    [
      renderPreloader.call(this, h),
      renderContent.call(this, h)
    ]
  )
}

function renderContainer(h) {
  return h(
    components.card,
    {
      class: `${className}-container`,
      props: {
        outline: true,
        rounded: true,
        overflow: true
      }
    },
    [ renderBody.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${className}`]: true,
        [`${className}--auth`]: !!this.account?.id
      }
    },
    [
      renderToc.call(this, h),
      renderContainer.call(this, h)
    ]
  )
}
